import { httpClient } from "../../../lib/http/axios";
import {
  type AuthzRoleConfigurationSuccessResponse,
  type AuthzRoleListSuccessResponse,
  type AuthzRoleStatusMutationRequest,
  type AuthzRoleSuccessResponse,
  mapAuthzRoleConfiguration,
  mapAuthzRoleConfigurationMutation,
  mapAuthzRoleCreateMutation,
  mapAuthzRoleItem,
  mapAuthzRoleList,
} from "../api/adapters";
import type {
  AuthzRoleConfiguration,
  AuthzRoleConfigurationMutation,
  AuthzRoleCreateMutation,
  AuthzRoleItem,
  AuthzRoleListQuery,
  AuthzRoleListResult,
  AuthzRoleStatus,
} from "../types";

/** 查询角色分页列表。 */
export async function fetchAuthzRoles(query: AuthzRoleListQuery): Promise<AuthzRoleListResult> {
  const response = await httpClient.get<AuthzRoleListSuccessResponse>("/authz/roles", {
    params: {
      keyword: query.keyword?.trim() || undefined,
      status: query.status,
      page: query.page,
      page_size: query.pageSize,
    },
  });
  return mapAuthzRoleList(response.data.data);
}

/** 新增通用角色。 */
export async function createAuthzRole(payload: AuthzRoleCreateMutation): Promise<AuthzRoleItem> {
  const response = await httpClient.post<AuthzRoleSuccessResponse>(
    "/authz/roles",
    mapAuthzRoleCreateMutation(payload),
  );
  return mapAuthzRoleItem(response.data.data);
}

/** 查询角色配置。 */
export async function fetchAuthzRoleConfiguration(roleId: number): Promise<AuthzRoleConfiguration> {
  const response = await httpClient.get<AuthzRoleConfigurationSuccessResponse>(
    `/authz/roles/${roleId}/configuration`,
  );
  return mapAuthzRoleConfiguration(response.data.data);
}

/** 保存角色基本信息、成员和权限。 */
export async function saveAuthzRoleConfiguration(
  roleId: number,
  payload: AuthzRoleConfigurationMutation,
): Promise<AuthzRoleConfiguration> {
  const response = await httpClient.put<AuthzRoleConfigurationSuccessResponse>(
    `/authz/roles/${roleId}/configuration`,
    mapAuthzRoleConfigurationMutation(payload),
  );
  return mapAuthzRoleConfiguration(response.data.data);
}

/** 启用或停用角色。 */
export async function updateAuthzRoleStatus(
  roleId: number,
  status: AuthzRoleStatus,
): Promise<AuthzRoleItem> {
  const payload: AuthzRoleStatusMutationRequest = { status };
  const response = await httpClient.put<AuthzRoleSuccessResponse>(`/authz/roles/${roleId}/status`, payload);
  return mapAuthzRoleItem(response.data.data);
}
